import "../styles/impressum-section.css";

const ImpressumElement = () => {
    return (
        <div className="impressum-container flex-se-c">
            <p>© 2020 by Metzgerei Heiko Brath  GmbH, Deutschland</p>
            <p>Code and design by StudioPresent</p>
        </div>
        );
}
 
export default ImpressumElement;